import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
import Contactos from './contactos';
import Desarrollos from './Desarrollos';
import Corretaje from './Corretaje';
import Agentes from './Agentes';
import Negocios from './Negocios';
import Movimientos from './Movimientos';
import Objetivos from './Objetivos';
import ReportesAutomaticos from './ReportesAutomaticos';
import PushNotificaciones from './PushNotificaciones';
import TendenciasProducto from './TendenciasProducto';
import BuyerPersona from './BuyerPersona';
import HistorialMovimientos from './HistorialMovimientos';
import DashboardDireccion from './DashboardDireccion';
import Guardias from './Guardias';
import Expedientes from './Expedientes';
import Leads from './Leads';
import Inbox from './Inbox';
import ReportesMarketing from './ReportesMarketing';
import LineasWhatsApp from './LineasWhatsApp';
import InactividadSesion, { CLAVE_ULTIMA_ACTIVIDAD, CLAVE_SESION_EXPIRADA } from './InactividadSesion';
// FIX: iconos de línea (lucide-react) en lugar de emojis en todo el sidebar.
// Requiere: npm install lucide-react
import {
  Trophy, Contact, Briefcase, Building2, Home, Users, Folder, Megaphone,
  Target, MessageSquare, TrendingUp, Calendar, Building, LineChart,
  ArrowLeftRight, FileText, Mail, ShieldCheck, Settings, LogOut, Flame, UserCheck, Phone,
} from 'lucide-react';

const MENU_COMPLETO = [
  { id: 'dashboard', label: 'Ranking BS', icon: 'dashboard' },
  { id: 'contactos', label: 'Contactos', icon: 'contactos' },
  { id: 'negocios', label: 'Negocios', icon: 'negocios' },
  { id: 'desarrollos', label: 'Desarrollos', icon: 'desarrollos' },
  { id: 'corretaje', label: 'Corretaje', icon: 'corretaje' },
  { id: 'agentes', label: 'Agentes', icon: 'agentes' },
  { id: 'expedientes', label: 'Expedientes', icon: 'expedientes' },
  { id: 'marketing', label: 'Marketing', icon: 'marketing', submenu: [
    { id: 'mkt_leads',    label: 'Leads',    icon: 'mkt_leads' },
    { id: 'mkt_inbox',    label: 'Chats',    icon: 'mkt_inbox' },
    { id: 'mkt_reportes', label: 'Reportes', icon: 'mkt_reportes' },
    { id: 'mkt_guardias', label: 'Guardias', icon: 'mkt_guardias' },
    { id: 'mkt_lineas',   label: 'Líneas de WhatsApp', icon: 'mkt_lineas' },
  ]},
  { id: 'direccion', label: 'Dirección', icon: 'direccion', submenu: [
    { id: 'dashboard_dir', label: 'Dashboard', icon: 'dashboard_dir' },
    { id: 'movimientos', label: 'Movimientos', icon: 'movimientos' },
    { id: 'historial', label: 'Historial', icon: 'historial' },
    { id: 'objetivos', label: 'Objetivos', icon: 'objetivos' },
    { id: 'reportes_auto', label: 'Reportes Automáticos', icon: 'reportes_auto' },
    { id: 'tendencias_producto', label: 'Tendencias', icon: 'tendencias_producto' },
    { id: 'buyer_persona', label: 'Buyer Persona', icon: 'buyer_persona' },
  ]},
];

// FIX: 'marketing' agregado a Gerente Editor y Gerente Operador — antes no
// tenían el módulo en absoluto. El filtro fino de qué ven dentro del
// submenú (solo Inbox, Reportes, Guardias) se aplica en submenuFiltrado
// dentro del componente Sidebar.
const MENU_POR_ROL = {
  'Super Admin': ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'agentes', 'expedientes', 'marketing', 'direccion'],
  'Admin':       ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'agentes', 'expedientes', 'marketing', 'direccion'],
  'Sub Admin':   ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'agentes', 'expedientes', 'marketing', 'direccion'],
  'Gerente Editor':   ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'expedientes', 'marketing', 'direccion'],
  'Gerente Operador': ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'expedientes', 'marketing', 'direccion'],
  // FIX: Gerente Externo — trabaja para el desarrollador, no para Black
  // Sheep. Sin Ranking BS, Corretaje, Agentes ni Marketing; solo su
  // trabajo (Contactos/Negocios/Desarrollos/Expedientes/Dirección de su
  // gente). El detalle fino de qué ve dentro de Dirección se filtra en
  // submenuFiltrado más abajo.
  'Gerente Externo':  ['contactos', 'negocios', 'desarrollos', 'expedientes', 'direccion'],
  'Agente':      ['dashboard', 'contactos', 'negocios', 'desarrollos', 'corretaje', 'expedientes'],
  // 'negocios' solo aparece si agentes.ver_negocios está activo (ver filtro en Sidebar).
  'Desarrollador': ['contactos', 'negocios', 'desarrollos', 'direccion'],
};

function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = React.useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  React.useEffect(() => {
    const handler = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return { isMobile, isTablet, isSmall: isMobile || isTablet };
}

function LogoBS({ small = false }) {
  if (small) {
    return (
      <svg width="32" height="32" viewBox="0 0 100 88" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" fill="#fff" d="M99.37,28.79c.04.37,0,.74,0,1.26-2.84.21-5.66.42-8.52.63-.18-.91-.31-1.72-.5-2.51-1.23-5.18-4.39-8.53-9.56-9.8-5-1.23-10.03-1.12-14.98.35-4.24,1.26-7.22,4.84-7.36,8.69-.14,3.64,1.38,6.46,4.75,7.79,3.57,1.4,7.29,2.48,11,3.45,5.24,1.37,10.61,2.33,15.61,4.52,4.48,1.96,8.2,4.83,10.23,9.45,3.59,8.15.61,17.88-7.09,23.03-5.58,4.24-13.74,4.39-13.74,4.39h-8.29c-7.34-.19-13.65-2.94-18.58-8.53-.07-.08-.17-.14-.34-.28-2.48,3.5-5.96,5.54-10.03,6.52-2.6.63-5.3,1.15-7.96,1.21-6.77.17-13.55.06-20.42.06v-7.94c.42,0,.82,0,1.22,0,6.03,0,12.06.05,18.09-.07,1.89-.03,3.81-.35,5.63-.83,4.35-1.15,6.88-4.12,7.64-8.49.75-4.28-.18-8.13-3.66-11.05-1.71-1.43-3.74-2.23-5.93-2.48-2.64-.3-5.29-.54-7.94-.59-4.6-.09-9.21-.03-13.82-.03h-1.26v-8.04c.51,0,.95,0,1.39,0,5.62-.03,11.23-.01,16.85-.14,1.7-.04,3.46-.29,5.08-.78,6.06-1.85,7.3-6.94,6.46-11.48-.84-4.56-3.63-7.18-8.26-7.74-2.59-.31-5.22-.45-7.83-.5-4.52-.08-9.05-.02-13.7-.02v-7.93c.17-.04.31-.11.44-.11,6.29.01,12.58-.03,18.87.08,3.04.05,6.03.58,8.89,1.71,3.65,1.45,6.48,3.83,8.41,7.26.15.26.29.52.44.78.14.25.27.51.43.8.88-1.36,1.63-2.73,2.58-3.94,2.97-3.76,9.07-7.27,17.23-7.78l9.51.21s18.15,2.7,19.04,18.87ZM43.01,42.72c.36.16.48.23.61.27,7.15,2.36,11.16,7.27,12.21,14.73.75,5.37,3.36,9.53,8.39,11.96,4.62,2.24,9.5,2.82,14.55,2.37,3.32-.3,6.47-1.14,9.31-2.98,6.2-4.02,6.71-13.33-.75-16.91-2.61-1.25-5.44-2.08-8.23-2.89-5.35-1.55-10.79-2.81-16.11-4.46-5.17-1.61-9.39-4.59-11.9-9.6-.02-.04-.12-.03-.25-.06-1.64,3.39-4.35,5.73-7.83,7.57Z"/>
      </svg>
    );
  }
  return (
    <svg width="180" height="38" viewBox="0 0 476 88" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" fill="#fff" d="M99.37,28.79c.04.37,0,.74,0,1.26-2.84.21-5.66.42-8.52.63-.18-.91-.31-1.72-.5-2.51-1.23-5.18-4.39-8.53-9.56-9.8-5-1.23-10.03-1.12-14.98.35-4.24,1.26-7.22,4.84-7.36,8.69-.14,3.64,1.38,6.46,4.75,7.79,3.57,1.4,7.29,2.48,11,3.45,5.24,1.37,10.61,2.33,15.61,4.52,4.48,1.96,8.2,4.83,10.23,9.45,3.59,8.15.61,17.88-7.09,23.03-5.58,4.24-13.74,4.39-13.74,4.39h-8.29c-7.34-.19-13.65-2.94-18.58-8.53-.07-.08-.17-.14-.34-.28-2.48,3.5-5.96,5.54-10.03,6.52-2.6.63-5.3,1.15-7.96,1.21-6.77.17-13.55.06-20.42.06v-7.94c.42,0,.82,0,1.22,0,6.03,0,12.06.05,18.09-.07,1.89-.03,3.81-.35,5.63-.83,4.35-1.15,6.88-4.12,7.64-8.49.75-4.28-.18-8.13-3.66-11.05-1.71-1.43-3.74-2.23-5.93-2.48-2.64-.3-5.29-.54-7.94-.59-4.6-.09-9.21-.03-13.82-.03h-1.26v-8.04c.51,0,.95,0,1.39,0,5.62-.03,11.23-.01,16.85-.14,1.7-.04,3.46-.29,5.08-.78,6.06-1.85,7.3-6.94,6.46-11.48-.84-4.56-3.63-7.18-8.26-7.74-2.59-.31-5.22-.45-7.83-.5-4.52-.08-9.05-.02-13.7-.02v-7.93c.17-.04.31-.11.44-.11,6.29.01,12.58-.03,18.87.08,3.04.05,6.03.58,8.89,1.71,3.65,1.45,6.48,3.83,8.41,7.26.15.26.29.52.44.78.14.25.27.51.43.8.88-1.36,1.63-2.73,2.58-3.94,2.97-3.76,9.07-7.27,17.23-7.78l9.51.21s18.15,2.7,19.04,18.87ZM43.01,42.72c.36.16.48.23.61.27,7.15,2.36,11.16,7.27,12.21,14.73.75,5.37,3.36,9.53,8.39,11.96,4.62,2.24,9.5,2.82,14.55,2.37,3.32-.3,6.47-1.14,9.31-2.98,6.2-4.02,6.71-13.33-.75-16.91-2.61-1.25-5.44-2.08-8.23-2.89-5.35-1.55-10.79-2.81-16.11-4.46-5.17-1.61-9.39-4.59-11.9-9.6-.02-.04-.12-.03-.25-.06-1.64,3.39-4.35,5.73-7.83,7.57Z"/>
      <path fill="#fff" d="M115.74,55.78v-21.2h7.95c1.62,0,2.92.21,3.9.64.98.43,1.74,1.09,2.3,1.98.55.89.83,1.82.83,2.8,0,.91-.25,1.76-.74,2.56-.49.8-1.23,1.45-2.23,1.94,1.28.38,2.27,1.02,2.96,1.92.69.91,1.03,1.98,1.03,3.21,0,.99-.21,1.92-.63,2.77-.42.85-.94,1.51-1.55,1.97-.62.46-1.39.81-2.32,1.05-.93.24-2.07.35-3.42.35h-8.09ZM118.54,43.49h4.58c1.24,0,2.14-.08,2.68-.25.71-.21,1.25-.56,1.61-1.06.36-.49.54-1.11.54-1.85,0-.7-.17-1.32-.51-1.86s-.82-.9-1.45-1.1c-.63-.2-1.7-.3-3.23-.3h-4.24v6.41ZM118.54,53.28h5.28c.91,0,1.54-.03,1.91-.1.65-.12,1.19-.31,1.62-.58.43-.27.79-.66,1.07-1.18.28-.52.42-1.11.42-1.79,0-.79-.2-1.48-.61-2.06-.41-.58-.97-.99-1.68-1.23-.72-.24-1.75-.35-3.1-.35h-4.9v7.29Z"/>
      <path fill="#fff" d="M151.19,55.78v-21.2h2.81v18.7h10.44v2.5h-13.25Z"/>
      <path fill="#fff" d="M181.15,55.78l8.14-21.2h3.02l8.68,21.2h-3.2l-2.47-6.42h-8.87l-2.33,6.42h-2.98ZM187.27,47.07h7.19l-2.21-5.87c-.68-1.78-1.18-3.25-1.5-4.4-.27,1.36-.65,2.71-1.14,4.05l-2.33,6.22Z"/>
      <path fill="#fff" d="M234.06,48.35l2.81.71c-.59,2.3-1.65,4.06-3.17,5.27-1.53,1.21-3.4,1.81-5.6,1.81s-4.14-.46-5.58-1.4c-1.43-.93-2.52-2.28-3.27-4.04-.75-1.76-1.12-3.66-1.12-5.68,0-2.21.42-4.13,1.27-5.78.84-1.64,2.04-2.89,3.6-3.75,1.56-.85,3.27-1.28,5.14-1.28,2.12,0,3.91.54,5.35,1.62s2.45,2.6,3.02,4.56l-2.76.65c-.49-1.54-1.21-2.67-2.14-3.37-.94-.7-2.11-1.06-3.53-1.06-1.63,0-2.99.39-4.09,1.17-1.09.78-1.86,1.83-2.31,3.15-.44,1.32-.67,2.67-.67,4.07,0,1.8.26,3.38.79,4.72.53,1.34,1.34,2.35,2.45,3.02s2.31,1,3.6,1c1.57,0,2.9-.45,3.99-1.36,1.09-.91,1.83-2.25,2.21-4.04Z"/>
      <path fill="#fff" d="M255.91,55.78v-21.2h2.81v10.51l10.53-10.51h3.8l-8.89,8.59,9.29,12.61h-3.7l-7.55-10.73-3.47,3.38v7.35h-2.81Z"/>
      <path fill="#fff" d="M307.92,48.97l2.65-.23c.12,1.06.42,1.93.87,2.61s1.17,1.23,2.13,1.65c.96.42,2.05.63,3.25.63,1.07,0,2.02-.16,2.83-.48.82-.32,1.43-.75,1.83-1.31.4-.55.6-1.16.6-1.81s-.19-1.25-.58-1.74c-.39-.5-1.02-.91-1.91-1.25-.57-.22-1.83-.57-3.77-1.03-1.95-.47-3.31-.91-4.09-1.32-1.01-.53-1.77-1.19-2.26-1.97-.5-.79-.75-1.67-.75-2.64,0-1.07.3-2.07.91-3,.61-.93,1.49-1.64,2.66-2.12,1.17-.48,2.46-.72,3.89-.72,1.57,0,2.96.25,4.16.76,1.2.51,2.12,1.25,2.77,2.23.65.98.99,2.1,1.04,3.34l-2.69.2c-.14-1.34-.63-2.35-1.47-3.04-.83-.68-2.07-1.03-3.7-1.03s-2.93.31-3.71.93c-.78.62-1.17,1.37-1.17,2.25,0,.76.28,1.39.83,1.88.54.49,1.95,1,4.23,1.51,2.28.52,3.84.97,4.69,1.35,1.23.57,2.15,1.29,2.73,2.16.59.87.88,1.88.88,3.02s-.32,2.19-.97,3.19c-.65,1-1.57,1.77-2.78,2.33-1.21.55-2.57.83-4.08.83-1.92,0-3.53-.28-4.82-.84-1.3-.56-2.31-1.4-3.05-2.52-.74-1.12-1.13-2.39-1.16-3.81Z"/>
      <path fill="#fff" d="M344.41,55.78v-21.2h2.81v8.71h11.02v-8.71h2.81v21.2h-2.81v-9.99h-11.02v9.99h-2.81Z"/>
      <path fill="#fff" d="M381.47,55.78v-21.2h15.33v2.5h-12.53v6.49h11.73v2.49h-11.73v7.22h13.02v2.5h-15.82Z"/>
      <path fill="#fff" d="M416.92,55.78v-21.2h15.33v2.5h-12.53v6.49h11.73v2.49h-11.73v7.22h13.02v2.5h-15.82Z"/>
      <path fill="#fff" d="M452.32,55.78v-21.2h8c1.41,0,2.48.07,3.23.2,1.04.17,1.91.5,2.62.99.7.49,1.27,1.17,1.7,2.05.43.88.64,1.84.64,2.89,0,1.8-.57,3.33-1.72,4.58-1.15,1.25-3.22,1.87-6.22,1.87h-5.44v8.62h-2.81ZM455.13,44.66h5.48c1.81,0,3.1-.34,3.86-1.01.76-.67,1.14-1.62,1.14-2.85,0-.89-.22-1.65-.67-2.28-.45-.63-1.04-1.05-1.77-1.25-.47-.12-1.34-.19-2.62-.19h-5.42v7.58Z"/>
    </svg>
  );
}

// FIX: iconos de línea (lucide-react) reemplazando emojis. size=18 y color
// heredado (currentColor) para que respeten el color activo/inactivo del
// botón que los contiene.
const MENU_ICONS = {
  dashboard: <Trophy size={18} />,
  contactos: <Contact size={18} />,
  negocios: <Briefcase size={18} />,
  desarrollos: <Building2 size={18} />,
  corretaje: <Home size={18} />,
  agentes: <Users size={18} />,
  expedientes: <Folder size={18} />,
  marketing: <Megaphone size={18} />,
  mkt_leads: <Target size={18} />,
  mkt_inbox: <MessageSquare size={18} />,
  mkt_lineas: <Phone size={18} />,
  mkt_reportes: <TrendingUp size={18} />,
  mkt_guardias: <Calendar size={18} />,
  direccion: <Building size={18} />,
  movimientos: <ArrowLeftRight size={18} />,
  dashboard_dir: <LineChart size={18} />,
  historial: <FileText size={18} />,
  objetivos: <Target size={18} />,
  reportes_auto: <Mail size={18} />,
  tendencias_producto: <Flame size={18} />,
  buyer_persona: <UserCheck size={18} />,
};

function Sidebar({ active, onNav, onLogout, miAgente, miRol, isOpen, onClose, isMobile, showAviso, onToggleAviso, rankingBsVisible, onToggleRankingBs, expedientesRechazados }) {
  // FIX: "Dirección" (y cualquier submenú) inicia cerrado por defecto en
  // vez de abierto. Antes: useState('direccion').
  const [submenuAbierto, setSubmenuAbierto] = React.useState(null);
  const menuPermitido = MENU_POR_ROL[miRol] || [];
  const menuVisible = MENU_COMPLETO.filter(item => {
    if (!menuPermitido.includes(item.id)) return false;
    if (item.id === 'dashboard' && miRol === 'Agente' && miAgente?.equipo !== 'Black Sheep') return false;
    if (item.id === 'dashboard' && miRol === 'Desarrollador') return false;
    // Negocios: el Desarrollador solo lo ve si el Super Admin se lo activó en Agentes.
    if (item.id === 'negocios' && miRol === 'Desarrollador' && !miAgente?.ver_negocios) return false;
    if (item.id === 'dashboard' && miRol !== 'Super Admin' && !rankingBsVisible) return false;
    return true;
  });
  const nombre = miAgente ? `${miAgente.nombre || ''} ${miAgente.apellidos || ''}`.trim() : '';
  const handleNav = (id) => { onNav(id); if (isMobile) onClose(); };
  if (isMobile && !isOpen) return null;

  return (
    <>
      {isMobile && isOpen && (
        <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 998 }} />
      )}
      <div style={{ width: '240px', height: '100dvh', background: '#111', display: 'flex', flexDirection: 'column', flexShrink: 0, position: isMobile ? 'fixed' : 'sticky', top: 0, left: 0, zIndex: 999, overflowY: 'auto', boxShadow: isMobile ? '4px 0 20px rgba(0,0,0,0.3)' : 'none', transition: 'transform 0.25s ease' }}>
        <div style={{ padding: '20px 16px', borderBottom: '0.5px solid rgba(255,255,255,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <LogoBS />
          {isMobile && <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#888', fontSize: '22px', cursor: 'pointer', padding: '4px' }}>✕</button>}
        </div>
        {nombre && (
          <div style={{ padding: '12px 16px', borderBottom: '0.5px solid rgba(255,255,255,0.06)' }}>
            <div style={{ fontSize: '11px', color: '#555' }}>Bienvenido,</div>
            <div style={{ fontSize: '13px', color: '#ccc', fontWeight: '500', marginTop: '2px' }}>{nombre}</div>
            <div style={{ fontSize: '11px', color: '#444', marginTop: '1px' }}>
              {miAgente?.equipo === 'Black Sheep' && miAgente?.codigo_agente ? miAgente.codigo_agente : miRol}
            </div>
          </div>
        )}
        <nav style={{ flex: 1, padding: '12px 8px' }}>
          {menuVisible.map(item => {
            const tieneSubmenu = item.submenu?.length > 0;
            const estaAbierto = submenuAbierto === item.id;
            const submenuActivo = item.submenu?.some(s => s.id === active);
            const isActive = active === item.id || submenuActivo;
            const submenuFiltrado = (item.submenu || []).filter(s => {
              if (miRol === 'Desarrollador') return s.id === 'dashboard_dir';
              if (s.id === 'historial') return miRol === 'Super Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador' || miRol === 'Gerente Externo';
              if (s.id === 'reportes_auto') return miRol === 'Super Admin' || miRol === 'Admin';
              if (s.id === 'tendencias_producto') return miRol === 'Super Admin' || miRol === 'Gerente Externo';
              if (s.id === 'buyer_persona') return miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador' || miRol === 'Gerente Externo';
              // FIX: Objetivos son metas internas de venta de Black Sheep —
              // Gerente Externo (representa al desarrollador, no es staff
              // interno) no debe verlas ni para su propio proyecto.
              if (s.id === 'objetivos') return miRol !== 'Gerente Externo';
              // FIX: las líneas de WhatsApp guardan credenciales de Meta --
              // solo Super Admin las administra, ningún otro rol las ve.
              if (s.id === 'mkt_lineas') return miRol === 'Super Admin';
              if (item.id === 'marketing' && (miRol === 'Gerente Editor' || miRol === 'Gerente Operador')) {
                return ['mkt_inbox', 'mkt_reportes', 'mkt_guardias'].includes(s.id);
              }
              return true;
            });
            return (
              <div key={item.id}>
                <button onClick={() => { if (tieneSubmenu) setSubmenuAbierto(estaAbierto ? null : item.id); else handleNav(item.id); }}
                  style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginBottom: '2px', fontSize: '14px', background: isActive && !tieneSubmenu ? '#fff' : tieneSubmenu && estaAbierto ? 'rgba(255,255,255,0.08)' : 'transparent', color: isActive && !tieneSubmenu ? '#000' : '#aaa', textAlign: 'left', fontWeight: isActive ? '600' : '400', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                      {MENU_ICONS[item.icon]}
                      {item.id === 'expedientes' && expedientesRechazados > 0 && (
                        <span style={{ position: 'absolute', top: '-3px', right: '-4px', width: '9px', height: '9px', borderRadius: '50%', background: '#E53935', border: '1.5px solid #111' }} />
                      )}
                    </span>
                    {item.label}
                  </div>
                  {tieneSubmenu && <span style={{ fontSize: '10px', color: '#555' }}>{estaAbierto ? '▾' : '▸'}</span>}
                  {item.id === 'dashboard' && miRol === 'Super Admin' && (
                    <span onClick={e => { e.stopPropagation(); onToggleRankingBs(); }}
                      title={rankingBsVisible ? 'Visible para todos — click para ocultar' : 'Oculto para los demás roles — click para mostrar'}
                      style={{ width: '32px', height: '18px', borderRadius: '10px', background: rankingBsVisible ? '#2E7D4F' : '#444', position: 'relative', flexShrink: 0, cursor: 'pointer' }}>
                      <span style={{ position: 'absolute', top: '2px', left: rankingBsVisible ? '16px' : '2px', width: '14px', height: '14px', borderRadius: '50%', background: '#fff', transition: 'left 0.15s' }} />
                    </span>
                  )}
                </button>
                {tieneSubmenu && estaAbierto && (
                  <div style={{ paddingLeft: '12px', marginBottom: '4px' }}>
                    {submenuFiltrado.map(sub => (
                      <button key={sub.id} onClick={() => handleNav(sub.id)}
                        style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginBottom: '2px', fontSize: '14px', background: active === sub.id ? '#fff' : 'transparent', color: active === sub.id ? '#000' : '#888', textAlign: 'left', fontWeight: active === sub.id ? '600' : '400' }}>
                        <span style={{ display: 'flex', alignItems: 'center' }}>{MENU_ICONS[sub.icon]}</span>
                        {sub.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        <div style={{ padding: '12px 8px', borderTop: '0.5px solid rgba(255,255,255,0.08)' }}>
          <button onClick={onToggleAviso}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginBottom: '2px', fontSize: '14px', background: showAviso ? 'rgba(255,255,255,0.1)' : 'transparent', color: showAviso ? '#fff' : '#aaa', textAlign: 'left' }}>
            <span style={{ display: 'flex', alignItems: 'center' }}><ShieldCheck size={18} /></span>
            Aviso de Privacidad
          </button>
          <button onClick={() => handleNav('micuenta')}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 12px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginBottom: '2px', fontSize: '14px', background: active === 'micuenta' ? '#fff' : 'transparent', color: active === 'micuenta' ? '#000' : '#aaa', textAlign: 'left' }}>
            <span style={{ display: 'flex', alignItems: 'center' }}><Settings size={18} /></span>
            Mi cuenta
          </button>
          <button onClick={onLogout}
            style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 12px', borderRadius: '8px', border: 'none', background: 'transparent', color: '#555', cursor: 'pointer', fontSize: '14px', textAlign: 'left' }}>
            <span style={{ display: 'flex', alignItems: 'center' }}><LogOut size={18} /></span>
            Cerrar sesión
          </button>
        </div>
      </div>
    </>
  );
}

function TopBar({ onMenuOpen, miAgente }) {
  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 100, background: '#111', padding: '0 16px', height: '56px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
      <button onClick={onMenuOpen} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '22px', cursor: 'pointer', padding: '8px', display: 'flex', alignItems: 'center' }}>☰</button>
      <LogoBS small />
      <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#333', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: '14px', fontWeight: '600' }}>
        {miAgente?.nombre?.[0]?.toUpperCase() || '?'}
      </div>
    </div>
  );
}

function Dashboard({ miRol }) {
  const [movimientos, setMovimientos] = React.useState([]);
  const [agentesBS, setAgentesBS] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [anioSel, setAnioSel] = React.useState(new Date().getFullYear());
  const { isMobile } = useIsMobile();

  React.useEffect(() => { cargarDatos(); }, [miRol]);

  const cargarDatos = async () => {
    setLoading(true);
    const [{ data: movData }, { data: agData }] = await Promise.all([
      supabase.from('movimientos').select('*').order('created_at', { ascending: true }),
      supabase.from('agentes').select('*').eq('equipo', 'Black Sheep').eq('activo', true).not('codigo_agente', 'is', null).neq('codigo_agente', ''),
    ]);
    // Aguamarina y Punta Sábalo solo los ve el Super Admin.
    setMovimientos((movData || []).filter(m => miRol === 'Super Admin' || !['Aguamarina', 'Punta Sábalo'].includes(m.desarrollo_nombre)));
    setAgentesBS(agData || []);
    setLoading(false);
  };

  const aniosDisponibles = [...new Set(movimientos.map(m => new Date(m.created_at).getFullYear()))].sort((a,b) => b-a);
  const movsAnio = movimientos.filter(m => new Date(m.created_at).getFullYear() === anioSel);

  const ranking = agentesBS.map(agente => {
    const nombreCompleto = `${agente.nombre} ${agente.apellidos}`.trim();
    const totalAnio = movsAnio.filter(m => m.tipo === 'Vendida' && m.vendedor === nombreCompleto).length;
    return { codigo: agente.codigo_agente, totalAnio };
  })
  .filter(a => a.totalAnio > 0)
  .sort((a, b) => b.totalAnio - a.totalAnio);

  const COLORES_RANKING = ['#10B981','#3B82F6','#F59E0B','#8B5CF6','#EF4444','#EC4899','#14B8A6','#F97316'];

  const medallaIcon = (i) => {
    if (i === 0) return '🥇';
    if (i === 1) return '🥈';
    if (i === 2) return '🥉';
    return `${i + 1}°`;
  };

  return (
    <div style={{ padding: isMobile ? '1rem' : '2rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Trophy size={28} color="#1a1a2e" />
          <div>
            <h2 style={{ fontSize: isMobile ? '17px' : '22px', fontWeight: '700', color: '#1a1a2e', margin: 0 }}>Ranking Black Sheep</h2>
            <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>Ventas acumuladas por agente · {anioSel}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
          <span style={{ fontSize: '12px', color: '#888' }}>Año:</span>
          <select value={anioSel} onChange={e => setAnioSel(parseInt(e.target.value))}
            style={{ padding: '6px 10px', border: '0.5px solid #ddd', borderRadius: '6px', fontSize: '13px', background: '#fff' }}>
            {(aniosDisponibles.length > 0 ? aniosDisponibles : [new Date().getFullYear()]).map(a => (
              <option key={a} value={a}>{a}</option>
            ))}
          </select>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: '#888' }}>Cargando...</div>
      ) : ranking.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '4rem', color: '#aaa', fontSize: '14px' }}>
          Sin ventas registradas en {anioSel}
        </div>
      ) : (
        <>
          {!isMobile && ranking.length >= 1 && (
            <div style={{ display: 'flex', gap: '12px', marginBottom: '1.5rem', alignItems: 'flex-end' }}>
              {ranking[1] ? (
                <div style={{ flex: 1, background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', borderTop: '3px solid #C0C0C0' }}>
                  <div style={{ fontSize: '28px', marginBottom: '8px' }}>🥈</div>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#e0e0e0', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontWeight: '700', color: '#666', fontSize: '13px' }}>{ranking[1].codigo}</span>
                  </div>
                  <div style={{ fontWeight: '700', fontSize: '16px', color: '#1a1a2e' }}>{ranking[1].codigo}</div>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: '#3B82F6', marginTop: '8px' }}>{ranking[1].totalAnio}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>ventas</div>
                </div>
              ) : <div style={{ flex: 1 }} />}

              <div style={{ flex: 1, background: '#1a1a2e', borderRadius: '12px', padding: '2rem', textAlign: 'center', borderTop: '3px solid #FFD700', transform: 'scale(1.05)', boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}>
                <div style={{ fontSize: '36px', marginBottom: '8px' }}>🥇</div>
                <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#333', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontWeight: '700', color: '#fff', fontSize: '14px' }}>{ranking[0].codigo}</span>
                </div>
                <div style={{ fontWeight: '700', fontSize: '18px', color: '#fff' }}>{ranking[0].codigo}</div>
                <div style={{ fontSize: '44px', fontWeight: '700', color: '#10B981', marginTop: '10px' }}>{ranking[0].totalAnio}</div>
                <div style={{ fontSize: '12px', color: '#aaa' }}>ventas</div>
              </div>

              {ranking[2] ? (
                <div style={{ flex: 1, background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', borderTop: '3px solid #CD7F32' }}>
                  <div style={{ fontSize: '28px', marginBottom: '8px' }}>🥉</div>
                  <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#e0e0e0', margin: '0 auto 12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontWeight: '700', color: '#666', fontSize: '13px' }}>{ranking[2].codigo}</span>
                  </div>
                  <div style={{ fontWeight: '700', fontSize: '16px', color: '#1a1a2e' }}>{ranking[2].codigo}</div>
                  <div style={{ fontSize: '36px', fontWeight: '700', color: '#F59E0B', marginTop: '8px' }}>{ranking[2].totalAnio}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>ventas</div>
                </div>
              ) : <div style={{ flex: 1 }} />}
            </div>
          )}

          <div style={{ background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: '12px', overflow: 'hidden' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#fafafa', borderBottom: '0.5px solid #e0e0e0' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: '600', color: '#555', width: '48px' }}>#</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Agente</th>
                  <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: '600', color: '#555' }}>Ventas del año</th>
                </tr>
              </thead>
              <tbody>
                {ranking.map((ag, i) => {
                  const color = COLORES_RANKING[i % COLORES_RANKING.length];
                  return (
                    <tr key={i} style={{ borderBottom: '0.5px solid #f0f0f0', background: i === 0 ? '#f9fffe' : 'transparent' }}>
                      <td style={{ padding: '14px 16px', fontSize: '20px', textAlign: 'center' }}>{medallaIcon(i)}</td>
                      <td style={{ padding: '14px 16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#f0f0f0', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <span style={{ fontSize: '12px', fontWeight: '700', color: '#888' }}>{ag.codigo}</span>
                          </div>
                          <div style={{ fontWeight: '600', color: '#1a1a2e', fontSize: '15px' }}>{ag.codigo}</div>
                        </div>
                      </td>
                      <td style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '700', fontSize: '24px', color }}>{ag.totalAnio}</td>
                    </tr>
                  );
                })}
                <tr style={{ borderTop: '1px solid #e0e0e0', background: '#fafafa' }}>
                  <td></td>
                  <td style={{ padding: '12px 16px', fontWeight: '700', color: '#555' }}>TOTAL</td>
                  <td style={{ padding: '12px 16px', textAlign: 'center', fontWeight: '700', color: '#1a1a2e', fontSize: '24px' }}>
                    {ranking.reduce((s, ag) => s + ag.totalAnio, 0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}

// FIX: la Edge Function crear-usuario también sirve para que un agente
// pueda auto-repararse: si su propia cuenta de Auth no coincide con el
// correo guardado (huérfana / duplicada de una importación vieja), se
// intenta el mismo cambio de contraseña vía la función administrativa
// (con paginación completa) en vez de solo el método de sesión propia,
// que puede quedar en un estado raro si la cuenta activa no es "la buena".
const EDGE_CREAR_USUARIO = 'https://sicnbvbiukyaqkerajxd.supabase.co/functions/v1/crear-usuario';
const ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNpY25idmJpdWt5YXFrZXJhanhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNjMwMTQsImV4cCI6MjA2MzkzOTAxNH0.wPRB3bJZH-3s0eLu_2QzdImW5NwZ04pnFo5NkkTaEyc';

function MiCuenta({ user, miRol }) {
  const [agente, setAgente] = useState(null);
  const [form, setForm] = useState({ nombre: '', apellidos: '', telefono: '', whatsapp: '' });
  const [passNueva, setPassNueva] = useState('');
  const [passConfirm, setPassConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [msgPass, setMsgPass] = useState('');
  const [guardando, setGuardando] = useState(false);
  const [cambiandoPass, setCambiandoPass] = useState(false);
  const { isMobile } = useIsMobile();
  const puedeEditar = miRol === 'Super Admin';

  useEffect(() => { cargarAgente(); }, []);

  const cargarAgente = async () => {
    const { data } = await supabase.from('agentes').select('*').eq('correo', user.email).single();
    if (data) { setAgente(data); setForm({ nombre: data.nombre || '', apellidos: data.apellidos || '', telefono: data.telefono || '', whatsapp: data.whatsapp || '' }); }
  };

  const handleGuardar = async () => {
    if (!puedeEditar) return;
    setGuardando(true);
    await supabase.from('agentes').update(form).eq('correo', user.email);
    setGuardando(false);
    setMsg('Datos actualizados correctamente');
    setTimeout(() => setMsg(''), 3000);
    cargarAgente();
  };

  // FIX: antes solo usaba supabase.auth.updateUser (sesión propia). Si la
  // sesión activa por alguna razón queda ligada a una cuenta distinta a
  // la "buena" (por el caos de cuentas huérfanas/duplicadas que veníamos
  // arrastrando), esto podía cambiar la contraseña de la cuenta
  // equivocada, dejando al agente sin poder entrar con la nueva. Ahora,
  // si el método de sesión falla, se intenta también vía la Edge Function
  // administrativa (que ya busca por correo con paginación completa),
  // como respaldo.
  const handleCambiarPass = async () => {
    setMsgPass('');
    if (!passNueva || passNueva.length < 6) { setMsgPass('Mínimo 6 caracteres'); return; }
    if (passNueva !== passConfirm) { setMsgPass('Las contraseñas no coinciden'); return; }
    setCambiandoPass(true);

    const { error } = await supabase.auth.updateUser({ password: passNueva });

    if (error) {
      // Respaldo: intentar por correo vía la Edge Function administrativa
      try {
        const res = await fetch(EDGE_CREAR_USUARIO, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${ANON_KEY}` },
          body: JSON.stringify({ action: 'cambiar_password', email: user.email, password: passNueva })
        });
        const result = await res.json();
        if (result.error) {
          setMsgPass('Error al cambiar contraseña: ' + result.error);
          setCambiandoPass(false);
          return;
        }
      } catch (err) {
        setMsgPass('Error al cambiar contraseña');
        setCambiandoPass(false);
        return;
      }
    }

    setCambiandoPass(false);
    setMsgPass('Contraseña actualizada');
    setPassNueva(''); setPassConfirm('');
    setTimeout(() => setMsgPass(''), 3000);
  };

  const campo = (label, key) => (
    <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #f0f0f0' }}>
      <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>{label}</span>
      <input value={form[key] || ''} onChange={e => setForm({ ...form, [key]: e.target.value })} readOnly={!puedeEditar}
        style={{ flex: 1, border: 'none', borderBottom: !puedeEditar ? 'none' : '0.5px solid #ccc', padding: '4px 0', fontSize: '13px', background: 'transparent', outline: 'none', color: !puedeEditar ? '#333' : '#111', cursor: !puedeEditar ? 'default' : 'text' }} />
    </div>
  );

  return (
    <div style={{ padding: isMobile ? '1rem' : '2rem' }}>
      <h2 style={{ fontSize: isMobile ? '17px' : '20px', fontWeight: '500', color: '#1a1a2e', marginBottom: '1.5rem' }}>Mi cuenta</h2>
      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '16px', maxWidth: '900px' }}>
        <div style={{ background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: '12px', padding: isMobile ? '1.25rem' : '2rem' }}>
          <div style={{ fontSize: '11px', color: '#888', fontWeight: '500', marginBottom: '1.5rem' }}>PERFIL</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: '0.5px solid #f0f0f0' }}>
            <div style={{ width: '64px', height: '64px', borderRadius: '50%', overflow: 'hidden', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              {agente?.foto_url ? <img src={agente.foto_url} alt="foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '20px', fontWeight: '600', color: '#888' }}>{(form.nombre?.[0] || '').toUpperCase()}{(form.apellidos?.[0] || '').toUpperCase()}</span>}
            </div>
            <div>
              <div style={{ fontSize: '15px', fontWeight: '600', color: '#1a1a2e' }}>{form.nombre} {form.apellidos}</div>
              <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>{agente?.rol}</div>
              <div style={{ fontSize: '12px', color: '#888' }}>{agente?.equipo}</div>
            </div>
          </div>
          {campo('Nombre', 'nombre')}
          {campo('Apellidos', 'apellidos')}
          <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #f0f0f0' }}>
            <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>Correo</span>
            <span style={{ fontSize: '13px', color: '#333', wordBreak: 'break-all' }}>{user.email}</span>
          </div>
          {campo('Teléfono', 'telefono')}
          {campo('WhatsApp', 'whatsapp')}
          <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #f0f0f0' }}>
            <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>Rol</span>
            <span style={{ fontSize: '13px', color: '#333' }}>{agente?.rol || '—'}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0' }}>
            <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>Equipo</span>
            <span style={{ fontSize: '13px', color: '#333' }}>{agente?.equipo || '—'}</span>
          </div>
          {msg && <div style={{ marginTop: '12px', padding: '10px', borderRadius: '8px', background: '#EAF3DE', color: '#27500A', fontSize: '13px' }}>{msg}</div>}
          {puedeEditar && (
            <button onClick={handleGuardar} disabled={guardando}
              style={{ marginTop: '1.5rem', padding: '12px 24px', background: '#4A4A4A', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', width: '100%' }}>
              {guardando ? 'Guardando...' : 'Guardar cambios'}
            </button>
          )}
        </div>
        <PushNotificaciones correo={user.email} />
        <div style={{ background: '#fff', border: '0.5px solid #e0e0e0', borderRadius: '12px', padding: isMobile ? '1.25rem' : '2rem', alignSelf: 'flex-start' }}>
          <div style={{ fontSize: '11px', color: '#888', fontWeight: '500', marginBottom: '1.5rem' }}>CAMBIAR CONTRASEÑA</div>
          <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #f0f0f0' }}>
            <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>Nueva contraseña</span>
            <input type='password' value={passNueva} onChange={e => setPassNueva(e.target.value)}
              style={{ flex: 1, border: 'none', borderBottom: '0.5px solid #ccc', padding: '4px 0', fontSize: '13px', background: 'transparent', outline: 'none' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '0.5px solid #f0f0f0' }}>
            <span style={{ width: '140px', fontSize: '13px', color: '#666', flexShrink: 0 }}>Confirmar</span>
            <input type='password' value={passConfirm} onChange={e => setPassConfirm(e.target.value)}
              style={{ flex: 1, border: 'none', borderBottom: '0.5px solid #ccc', padding: '4px 0', fontSize: '13px', background: 'transparent', outline: 'none' }} />
          </div>
          {msgPass && (
            <div style={{ marginTop: '12px', padding: '10px', borderRadius: '8px', fontSize: '13px',
              background: msgPass.includes('Error') || msgPass.includes('coinciden') || msgPass.includes('Mínimo') ? '#FCEBEB' : '#EAF3DE',
              color: msgPass.includes('Error') || msgPass.includes('coinciden') || msgPass.includes('Mínimo') ? '#A32D2D' : '#27500A' }}>
              {msgPass}
            </div>
          )}
          <button onClick={handleCambiarPass} disabled={cambiandoPass}
            style={{ marginTop: '1.5rem', padding: '12px 24px', background: '#4A4A4A', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', width: '100%' }}>
            {cambiandoPass ? 'Actualizando...' : 'Actualizar contraseña'}
          </button>
        </div>
      </div>
    </div>
  );
}

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sesionExpirada] = useState(() => {
    try {
      const v = localStorage.getItem(CLAVE_SESION_EXPIRADA) === '1';
      localStorage.removeItem(CLAVE_SESION_EXPIRADA);
      return v;
    } catch (e) { return false; }
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    const { error, data } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError('Correo o contraseña incorrectos');
    } else if (data?.user) {
      try { localStorage.setItem(CLAVE_ULTIMA_ACTIVIDAD, String(Date.now())); } catch (e) { /* sin almacenamiento */ }
      await supabase.from('agentes').update({ last_sign_in: new Date().toISOString() }).eq('correo', email);
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div style={{ background: '#1a1a1a', padding: '2rem', borderRadius: '12px', border: '0.5px solid rgba(255,255,255,0.1)', width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <LogoBS />
          <p style={{ fontSize: '13px', color: '#666', marginTop: '12px' }}>Inicia sesión para continuar</p>
        </div>
        {sesionExpirada && !error && <div style={{ background: '#2a2a1a', color: '#e6d27a', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '1rem' }}>Tu sesión se cerró por inactividad. Inicia sesión de nuevo.</div>}
        {error && <div style={{ background: '#3a1a1a', color: '#ff8080', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '1rem' }}>{error}</div>}
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>Correo</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              style={{ width: '100%', padding: '12px', border: '0.5px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '15px', boxSizing: 'border-box', background: '#111', color: '#fff' }}
              placeholder="tu@email.com" />
          </div>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontSize: '12px', color: '#666', display: 'block', marginBottom: '4px' }}>Contraseña</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
              style={{ width: '100%', padding: '12px', border: '0.5px solid rgba(255,255,255,0.1)', borderRadius: '8px', fontSize: '15px', boxSizing: 'border-box', background: '#111', color: '#fff' }}
              placeholder="••••••••" />
          </div>
          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '14px', background: '#fff', color: '#000', border: 'none', borderRadius: '8px', fontSize: '15px', fontWeight: '600', cursor: 'pointer' }}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

function AvisoPrivacidadModal({ onClose }) {
  const { isMobile } = useIsMobile();
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '640px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 32px rgba(0,0,0,0.25)' }}>
        <div style={{ padding: isMobile ? '1.25rem 1.5rem' : '1.5rem 2rem', borderBottom: '0.5px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', margin: 0, color: '#1a1a2e' }}>Aviso de Privacidad</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#888' }}>×</button>
        </div>
        <div style={{ padding: isMobile ? '1.25rem 1.5rem' : '1.5rem 2rem', overflowY: 'auto', fontSize: '13px', lineHeight: '1.7', color: '#333' }}>
          <p>De acuerdo a lo previsto en la "Ley Federal de Protección de Datos Personales en Posesión de los Particulares", declara Black Sheep Real Estate SA de CV (BS), ser una sociedad legalmente constituida de conformidad con las leyes mexicanas, con domicilio en: Ruben Dario 1531B, Primer Piso, Colonia Providencia, Guadalajara, Jalisco, es responsable de recabar sus datos personales, del uso que se le dé a los mismos y de su protección.</p>
          <p>Su información personal será utilizada para proveerle de servicios ó de bienes que solicite, ó bien para identificarlo en cualquier tipo de relación jurídica ó de negocios entre Usted y nosotros, además para informarle sobre cambios en los mismos y evaluar la calidad del servicio que le brindamos.</p>
          <p>Para las finalidades antes mencionadas, requerimos obtener entre otros, los siguientes datos personales: <strong>[nombre completo y apellidos], [nacionalidad], [domicilio y teléfono particulares], [ocupación, domicilio y teléfono del lugar de trabajo], [ingresos mensuales], [estado civil], [régimen matrimonial]</strong> y de su Cónyuge: <strong>[nombre completo y apellidos], [ocupación, domicilio y teléfono del lugar de trabajo e ingresos mensuales]</strong>; manifestando que no se le pedirán datos personales catalogados como sensibles, según la Ley Federal de Protección de Datos Personales en Posesión de los Particulares.</p>
          <p>Para ejercitar sus derechos de acceder, rectificar y cancelar sus datos personales, así como de oponerse al tratamiento de los mismos o revocar el consentimiento que para tal fin nos haya otorgado, lo podrá hacer a través de los procedimientos que hemos implementado. Para conocer dichos procedimientos, los requisitos y plazos, se puede poner en contacto con nuestro Departamento Jurídico Corporativo, en el domicilio señalado en este documento.</p>
          <p>Asimismo, le informamos que sus datos personales pueden ser transferidos y tratados dentro y fuera del país, por personas distintas a esta empresa. En ese sentido, su información puede ser compartida con personas físicas o morales, con las cuales tenemos algún tipo de relación jurídica o de negocios como <strong>[entidades inmobiliarias, de corretaje, financieras, hipotecarias, e instituciones de vivienda]</strong>, para <strong>[fines mercadológicos, de factoraje, financieros, crediticios e hipotecarios]</strong>, a efecto de proveerle adecuadamente los servicios y productos que ha solicitado, o bien para entablar cualquier tipo de relación jurídica o de negocios. Se entenderá que ha otorgado su consentimiento si usted no manifiesta su oposición para que sus datos personales sean transferidos al presentarle el presente aviso de privacidad.</p>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#1a1a2e', marginTop: '1.5rem', marginBottom: '0.5rem' }}>ACUERDO DE CONFIDENCIALIDAD</h4>
          <p>La información a la que tendrán acceso es estrictamente confidencial y de uso exclusivo para los fines autorizados por Black Sheep Real Estate, al aceptar el acceso reconocen y comprometen a:</p>
          <ul style={{ paddingLeft: '20px', margin: '0 0 1rem' }}>
            <li>No distribuir, copiar ni reproducir dicha información por ningún medio digital o físico, sin la autorización expresa de Black Sheep Real Estate.</li>
            <li>Proteger la información contra cualquier uso indebido, pérdida, alteración o acceso no autorizado.</li>
            <li>Informar de inmediato en caso de detectar un uso indebido o sospecha de vulneración de la confidencialidad.</li>
          </ul>
          <p>El incumplimiento de estas obligaciones podrá dar lugar a responsabilidades legales incluyendo sanciones conforme a la normativa aplicable.</p>
        </div>
        <div style={{ padding: isMobile ? '1rem 1.5rem' : '1.25rem 2rem', borderTop: '0.5px solid #f0f0f0', flexShrink: 0 }}>
          <button onClick={onClose} style={{ width: '100%', padding: '12px', background: '#4A4A4A', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '500' }}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
}

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState('desarrollos');
  const [miAgente, setMiAgente] = useState(null);
  const [miRol, setMiRol] = useState('Agente');
  const [rankingBsVisible, setRankingBsVisible] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showAviso, setShowAviso] = useState(false);
  // FIX: aviso automático al entrar al CRM si tengo documentos de
  // expedientes rechazados pendientes de volver a subir.
  const [expedientesRechazados, setExpedientesRechazados] = useState(0);
  const { isMobile } = useIsMobile();

  const cargarExpedientesRechazados = async (correo) => {
    if (!correo) { setExpedientesRechazados(0); return; }
    const { count } = await supabase.from('expediente_documentos')
      .select('*', { count: 'exact', head: true })
      .eq('subido_por', correo).eq('estado_revision', 'rechazado');
    setExpedientesRechazados(count || 0);
  };

  // FIX BUG RANKING BS: si la tabla `configuracion` no tiene una policy de
  // RLS que permita SELECT a todos los roles autenticados, Supabase no
  // regresa error — simplemente entrega `data: []` en silencio (RLS
  // filtra filas, no lanza excepción). Antes, cuando `data` venía vacío,
  // el código asumía `true` (visible) por default, así que cualquier
  // agente sin permiso de lectura sobre `configuracion` veía Ranking BS
  // aunque el Super Admin lo hubiera apagado. Ahora: (1) se loguea el
  // error si existe, (2) el default cuando no hay dato pasa de `true` a
  // `false` (más seguro — oculto por default en vez de expuesto).
  // FIX DE FONDO (ejecutar en Supabase SQL Editor):
  //   create policy "Todos los autenticados pueden leer configuracion"
  //   on configuracion for select to authenticated using (true);
  const cargarConfigRankingBs = async () => {
    const { data, error } = await supabase.from('configuracion').select('valor').eq('clave', 'ranking_bs_visible').limit(1);
    if (error) console.error('Error leyendo configuracion (revisar RLS):', error);
    setRankingBsVisible(data && data.length > 0 ? data[0].valor === 'true' : false);
  };

  const handleToggleRankingBs = async () => {
    const nuevoValor = !rankingBsVisible;
    setRankingBsVisible(nuevoValor);
    const { error } = await supabase.from('configuracion').upsert({ clave: 'ranking_bs_visible', valor: String(nuevoValor) }, { onConflict: 'clave' });
    if (error) {
      alert('No se pudo guardar el cambio en el servidor: ' + error.message);
      setRankingBsVisible(!nuevoValor);
    }
  };

  const cargarAgente = async (email, esPrimerLogin = false) => {
    const { data } = await supabase.from('agentes').select('*').eq('correo', email).single();
    setMiAgente(data || null);
    setMiRol(data?.rol || 'Agente');
    cargarExpedientesRechazados(data?.correo);
    if (esPrimerLogin) {
      if (data?.rol === 'Desarrollador') {
        setActivePage('dashboard_dir');
      } else if (data?.rol === 'Agente' && data?.equipo === 'Black Sheep') {
        // FIX: mismo fallback seguro (false) que cargarConfigRankingBs +
        // log de error si la lectura falla por RLS.
        const { data: config, error } = await supabase.from('configuracion').select('valor').eq('clave', 'ranking_bs_visible').limit(1);
        if (error) console.error('Error leyendo configuracion (revisar RLS):', error);
        const visible = config && config.length > 0 ? config[0].valor === 'true' : false;
        setActivePage(visible ? 'dashboard' : 'desarrollos');
      } else {
        setActivePage('desarrollos');
      }
    }
  };

  useEffect(() => {
    cargarConfigRankingBs();
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
      if (session) cargarAgente(session.user.email, false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
      if (session) {
        const yaEstabaLogueado = sessionStorage.getItem('bs_logueado') === '1';
        if (!yaEstabaLogueado) { sessionStorage.setItem('bs_logueado', '1'); cargarAgente(session.user.email, true); }
        else cargarAgente(session.user.email, false);
      } else { sessionStorage.removeItem('bs_logueado'); }
    });
    return () => subscription.unsubscribe();
  }, []);

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        if (miRol === 'Agente' && miAgente?.equipo !== 'Black Sheep') return <Desarrollos miRol={miRol} miAgente={miAgente} />;
        if (miRol === 'Gerente Externo') return <Desarrollos miRol={miRol} miAgente={miAgente} />;
        if (miRol !== 'Super Admin' && !rankingBsVisible) return <Desarrollos miRol={miRol} miAgente={miAgente} />;
        return <Dashboard miRol={miRol} />;
      case 'contactos': return <Contactos />;
      case 'negocios': return (miRol === 'Desarrollador' && !miAgente?.ver_negocios) ? <Desarrollos miRol={miRol} miAgente={miAgente} /> : <Negocios />;
      case 'desarrollos': return <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'corretaje': return <Corretaje miRol={miRol} miAgente={miAgente} />;
      case 'agentes': return <Agentes />;
      case 'expedientes': return <Expedientes miRol={miRol} miAgente={miAgente} />;
      case 'movimientos': return <Movimientos />;
      case 'dashboard_dir': return <DashboardDireccion miRol={miRol} miAgente={miAgente} />;
      case 'historial': return (miRol === 'Super Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador' || miRol === 'Gerente Externo') ? <HistorialMovimientos miRol={miRol} miAgente={miAgente} /> : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'objetivos': return miRol !== 'Gerente Externo' ? <Objetivos miRol={miRol} miAgente={miAgente} /> : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'reportes_auto': return <ReportesAutomaticos miRol={miRol} />;
      case 'tendencias_producto': return (miRol === 'Super Admin' || miRol === 'Gerente Externo') ? <TendenciasProducto miRol={miRol} miAgente={miAgente} /> : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'buyer_persona':
        return (miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador' || miRol === 'Gerente Externo')
          ? <BuyerPersona miRol={miRol} miAgente={miAgente} />
          : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'mkt_guardias':
        return (miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Sub Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador')
          ? <Guardias miRol={miRol} miAgente={miAgente} />
          : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'mkt_leads':
        return (miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Sub Admin')
          ? <Leads miRol={miRol} miAgente={miAgente} />
          : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'mkt_inbox':
        return (miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Sub Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador')
          ? <Inbox miRol={miRol} miAgente={miAgente} />
          : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'mkt_reportes':
        return (miRol === 'Super Admin' || miRol === 'Admin' || miRol === 'Sub Admin' || miRol === 'Gerente Editor' || miRol === 'Gerente Operador')
          ? <ReportesMarketing miRol={miRol} miAgente={miAgente} />
          : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'mkt_lineas':
        return miRol === 'Super Admin' ? <LineasWhatsApp miRol={miRol} /> : <Desarrollos miRol={miRol} miAgente={miAgente} />;
      case 'micuenta': return <MiCuenta user={session.user} miRol={miRol} />;
      default: return <Desarrollos miRol={miRol} miAgente={miAgente} />;
    }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ textAlign: 'center' }}><LogoBS small /><div style={{ marginTop: '12px', fontSize: '13px', color: '#888' }}>Cargando...</div></div>
    </div>
  );
  if (!session) return <Login />;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f5f5' }}>
      <Sidebar
        active={activePage} onNav={setActivePage}
        onLogout={() => supabase.auth.signOut()}
        miAgente={miAgente} miRol={miRol}
        isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}
        isMobile={isMobile}
        showAviso={showAviso}
        onToggleAviso={() => setShowAviso(o => !o)}
        rankingBsVisible={rankingBsVisible}
        onToggleRankingBs={handleToggleRankingBs}
        expedientesRechazados={expedientesRechazados}
      />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        {isMobile && <TopBar onMenuOpen={() => setSidebarOpen(true)} miAgente={miAgente} />}
        <main style={{ flex: 1, overflow: 'auto' }}>
          {renderPage()}
        </main>
      </div>
      {showAviso && <AvisoPrivacidadModal onClose={() => setShowAviso(false)} />}
      <InactividadSesion />
    </div>
  );
}

export default App;